<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">{{ titulo }}</span>
                    </b-card-header>
                    <b-card-body>
                        <slot name="controles"></slot>
                        <app-tabela
                            idTabela="tblDespViagens"
                            :itens="despViagens"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="natureza" slot-scope="data">
                                <app-status
                                    :status="data.natureza"
                                ></app-status>
                            </template>
                            <template slot="contratacao" slot-scope="data">
                                <app-contratacao-detalhar
                                    :contratacao="data.contratacao"
                                ></app-contratacao-detalhar>
                            </template>
                            <template slot="valor" slot-scope="data">{{
                                data.valor | currency
                            }}</template>
                            <template slot="acoes" slot-scope="data">
                                <slot
                                    name="despViagemAcoes"
                                    v-bind="data"
                                ></slot>
                            </template>
                            <template
                                slot="despViagemSelecao"
                                slot-scope="data"
                                v-if="incluirSelecao"
                            >
                                <slot
                                    name="despViagemSelecao"
                                    v-bind="data"
                                ></slot>
                            </template>
                            <template slot="statusIdRm" slot-scope="data">
                                <app-status
                                    :status="data.statusIdRmDescr"
                                    v-if="
                                        data.statusIdRm != 1 &&
                                            data.statusIdRm != 2
                                    "
                                ></app-status>
                                <desp-viagem-erro-comprometimento
                                    :natureza="obterDespViagem(data)"
                                    :movimentosServicos="movimentosServicos"
                                ></desp-viagem-erro-comprometimento>
                                <span
                                    v-if="
                                        data.statusIdRm == 1 ||
                                            data.statusIdRm == 2
                                    "
                                >
                                    {{ data.idRm }}
                                    <status-fin
                                        :status="data.statusFinIdRm"
                                    ></status-fin>
                                </span>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ContratacaoDetalhar from './../contratacoes/ContratacaoDetalhar2'
import DespViagemErroComprometimento from './DespViagemErroComprometimento'
import StatusFin from './../StatusFinIdRm'

export default {
    props: {
        despViagens: {
            type: Array,
            default: () => []
        },

        incluirSelecao: {
            type: Boolean,
            default: false
        },

        titulo: {
            type: String,
            default: 'Despesas de Viagens'
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        },

        mostrarAcoes: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'contratacao',
                    label: 'Contratação',
                    filterable: true
                },
                {
                    key: 'natureza',
                    label: 'Natureza',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'statusIdRm',
                    label: 'Comprometimento'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterDespViagem(itemDespViagem) {
            return {
                codContratacao: itemDespViagem.contratacao.codContratacao,
                nome: itemDespViagem.natureza,
                status: itemDespViagem.statusIdRmDescr,
                idRm: itemDespViagem.IdRm
            }
        }
    },

    computed: {},

    created() {
        if (this.incluirSelecao) {
            this.campos.pop()
            this.campos.unshift({
                key: 'despViagemSelecao',
                label: ''
            })
        }

        if (!this.mostrarAcoes) {
            this.campos.pop()
        }
    },

    components: {
        AppContratacaoDetalhar: ContratacaoDetalhar,
        DespViagemErroComprometimento: DespViagemErroComprometimento,
        StatusFin: StatusFin
    }
}
</script>
